var map = {
	"./de/triangle-icon.png": "wuAI",
	"./en/triangle-icon.png": "HdBQ",
	"./es/triangle-icon.png": "Bva9",
	"./fr/triangle-icon.png": "e40j",
	"./ja/triangle-icon.png": "IDbY",
	"./ko/triangle-icon.png": "bqu/",
	"./pt/triangle-icon.png": "B8rC",
	"./ru/triangle-icon.png": "lTPg",
	"./tc/triangle-icon.png": "SF2z",
	"./th/triangle-icon.png": "IAqk"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "hJW7";